import { BaseIcon, BaseIconProps } from './BaseIcon';

export const ChipGradient: React.FC<BaseIconProps> = (props) => (
  <BaseIcon gradientId="chipGrad" {...props}>
    <rect width="16" height="16" x="4" y="4" rx="2" stroke="url(#chipGrad)" />
    <rect width="6" height="6" x="9" y="9" rx="1" stroke="url(#chipGrad)" />
    <path d="M15 2v2M15 20v2M2 15h2M2 9h2M20 15h2M20 9h2M9 2v2M9 20v2" stroke="url(#chipGrad)" />
  </BaseIcon>
);
